import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../api/client';

export type Classroom = { name: string };

export const classroomKey = ['classroom'] as const;

/** The classroom's name: on the sheet, in the toolbar and in the Uiterlijk panel. */
export function useClassroom() {
  return useQuery({
    queryKey: classroomKey,
    queryFn: async () => (await (await apiFetch('/api/classroom')).json()) as Classroom,
    staleTime: 60_000,
  });
}

export function useClassroomMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (name: string) =>
      (await (
        await apiFetch('/api/classroom', { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name }) })
      ).json()) as Classroom,
    onSuccess: (classroom) => queryClient.setQueryData(classroomKey, classroom),
  });
}
